import styled, { css } from 'styled-components';
import { th, variants } from 'style/theme';
import { sizes } from 'style';
import { P, H6 } from 'components/Typography';
import { motion } from 'framer-motion';
import Alert from 'components/Alert';

export const MyProductsCard = styled(motion.div)`
  border-radius: 7px;
  padding: 16px 22px;
  background-color: ${th('colors.fiord')};
  width: 100%;
  margin-bottom: auto;

  @media ${sizes.tabletPortrait} {
    width: 350px;
    margin-right: 45px;
  }
`;

export const Heading = styled(H6)`
  font-size: 14px;
`;

export const ProductsSection = styled.div`
  padding: 8px 14px 18px 14px;
  background-color: ${th('colors.transparentBlack.3')};
  border-radius: 7px;
  margin-top: 14px;
`;

export const SectionTitle = styled(P)`
  font-size: 13px;
  color: ${th('colors.transparentWhite.5')};
`;

export const ActiveProductsAlert = styled(Alert)`
  margin: 16px 0 20px 0;
`;

export const ProductLink = styled.a`
  border-radius: 7px;
  padding: 16px 22px;
  width: 100%;
  margin-bottom: auto;
  border: none;
  font-size: 23px;
  font-family: serif;
  font-weight: bold;
  text-decoration: none;
  opacity: ${(props) => (props.inactive ? 0.7 : 0.9)};
  height: 62px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-top: 18px;
  color: #fff;

  transition: transform 0.15s ease-out, opacity 0.2s ease;

  ${variants('variant', {
    remotehealth: css`
      background-color: ${th('colors.indigo')};
    `,
    nomadinsurance: css`
      background-color: ${th('colors.turquoise')};
    `,
    nomadhealth: css`
      background-color: ${th('colors.turquoise')};
    `
  })}

  :hover {
    transform: translateY(-2px);
    opacity: 1;
  }
`;
